import { z } from 'zod';
/** What produced the payload a flow run starts with. */
export var FlowRunStartDataType;
(function (FlowRunStartDataType) {
    FlowRunStartDataType["IncomingSms"] = "INCOMING_SMS";
    FlowRunStartDataType["Inputs"] = "INPUTS";
    FlowRunStartDataType["EventTrigger"] = "EVENT_TRIGGER";
    FlowRunStartDataType["ScheduleTrigger"] = "SCHEDULE_TRIGGER";
    FlowRunStartDataType["Unknown"] = "UNKNOWN";
})(FlowRunStartDataType || (FlowRunStartDataType = {}));
export const FlowRunIncomingSmsStartDataSchema = z.object({
    content: z.string(),
    conversation: z.any().optional(),
    timestamp: z.string(),
    chatSession: z.any().optional(),
    metadata: z.record(z.string(), z.any()).optional(),
});
export const FlowRunEventTriggerStartDataSchema = z.object({
    eventTriggerIds: z.array(z.string()),
});
export const FlowRunScheduleTriggerStartDataSchema = z.object({
    scheduleTriggerId: z.uuid(),
    flowRunId: z.uuid().optional(),
});
/** Start data whose shape the flow itself gives meaning to, such as a flow's declared inputs. */
export const FlowRunUnknownStartDataSchema = z.record(z.string(), z.unknown());
/**
 * Start data a caller may send when it starts a run.
 *
 * Narrower than the column it lands in: the event and schedule variants are written by flow-api
 * itself when a trigger fires, so a request cannot claim to be one.
 */
export const FlowRunStartDataSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(FlowRunStartDataType.IncomingSms),
        data: FlowRunIncomingSmsStartDataSchema,
    }),
    z.object({
        type: z.literal(FlowRunStartDataType.Inputs),
        data: FlowRunUnknownStartDataSchema,
    }),
    z.object({
        type: z.literal(FlowRunStartDataType.Unknown),
        data: FlowRunUnknownStartDataSchema,
    }),
]);
//# sourceMappingURL=startData.js.map